import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CheckBox from "components/LabelInput/CheckBox";
import NormalBtn from "components/NewButton/NormalBtn";
import { useState } from "react";
import CloseIcon from "../../assets/icon/pop-close@3x.png";

const PopupAlert = (props) => {
  const [checked, setChecked] = useState(false);
  const { isOpen, onClose, title, Content, width, rootStyle, reqConfirm, showTodayNotice } = props;

  const titleStyle = {
    height: "3rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "AppleSDGothicNeo",
    fontSize: "1.125rem",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#032063",
  };

  const modalClose = {
    height: "0.875rem",
    width: "0.875rem",
  };

  const contentsStyle = {
    fontFamily: "AppleSDGothicNeo",
    fontSize: props.fontSize ? props.fontSize : "0.938rem",
    fontWeight: props.fontWeight ? props.fontWeight : "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: props.color ? props.color : "#000",
  };

  // 오늘 하루 보지 않기 날짜 저장
  const saveDontShowToday = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem(`dontShowToday`, today);
  };

  const handleOkClick = () => {
    if (checked) {
      saveDontShowToday();
    }

    if (props.onBtnOkCallback) {
      props.onBtnOkCallback();
    }
  };

  return (
    <div style={rootStyle}>
      <Dialog
        open={isOpen}
        onClose={reqConfirm ? () => {} : onClose}
        transitionDuration={{ enter: 100, exit: 100 }}
        maxWidth={false}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (props.onBtnYesCallback) props.onBtnYesCallback();
            else if (props.onBtnOkCallback) props.onBtnOkCallback();
          }
        }}
      >
        {/* <DialogTitle > */}
        <div style={titleStyle}>
          {title}
          {reqConfirm ? (
            <></>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                float: "right",
                width: "2.875rem",
                height: "3rem",
                cursor: "pointer",
                position: "absolute",
                right: "0",
                top: "0",
              }}
              onClick={() => onClose()}
            >
              <img style={modalClose} src={CloseIcon} alt="" />
            </div>
          )}
        </div>
        {/* </DialogTitle> */}
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "#b8b8b8",
          }}
        ></div>
        <DialogContent style={contentsStyle}>{Content}</DialogContent>
        {/* <DialogActions style={actionStyle}>{ActionButtons}</DialogActions> */}
        <div
          style={{
            display: "flex",
            justifyContent: showTodayNotice ? "space-evenly" : "center",
            alignItems: "center",
            marginTop: "1rem",
            marginBottom: "1rem",
            minWidth: "20rem",
            width: width ? width : "",
            paddingLeft: showTodayNotice ? "0.5rem" : "0",
            paddingRight: showTodayNotice ? "0.5rem" : "0",
          }}
        >
          {/* 체크박스를 왼쪽에 배치 */}
          {showTodayNotice && (
            <CheckBox
              labelText="오늘 하루동안 보지 않기"
              fontSize="0.875rem"
              width="1.825rem"
              marginTop="0"
              marginLeft="0"
              defaultValue={false}
              onChangeCallback={(e) => {
                setChecked(e.checked);
              }}
            />
          )}

          {props.onBtnOkCallback !== undefined ? (
            <NormalBtn name="확인" onClick={handleOkClick} />
          ) : (
            ""
          )}

          {props.onBtnYesCallback !== undefined ? (
            <NormalBtn name="예" onClick={props.onBtnYesCallback} />
          ) : (
            ""
          )}

          {props.onBtnNoCallback !== undefined ? (
            <div
              style={{
                marginLeft: "0.75rem",
              }}
            >
              <NormalBtn theme="white" name="아니오" onClick={props.onBtnNoCallback} />
            </div>
          ) : (
            ""
          )}

          {props.onBtnCancelCallback !== undefined ? (
            <div
              style={{
                marginLeft: "0.75rem",
              }}
            >
              <NormalBtn name="취소" onClick={props.onBtnCancelCallback} />
            </div>
          ) : (
            ""
          )}

          {props.onBtnCloseCallback !== undefined ? (
            <div
              style={{
                marginLeft: "0.75rem",
              }}
            >
              <NormalBtn theme="gray" name="닫기" onClick={props.onBtnCloseCallback} />
            </div>
          ) : (
            ""
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default PopupAlert;
